import type { EventModel } from '@site/shared'
import { SITE_TIME_ZONE } from '@/site.config'
import { useTranslation } from '@/lib/i18n/LocaleContext'

const dayMonth = (iso: string, locale: string) =>
  new Date(iso).toLocaleDateString(locale, { day: 'numeric', month: 'short', timeZone: SITE_TIME_ZONE })

export function EventCard({ event: e }: { event: EventModel }) {
  const { t, locale } = useTranslation()
  const start = dayMonth(e.startsAt, locale)
  const end = e.endsAt ? dayMonth(e.endsAt, locale) : undefined
  return (
    <div className="card event-card">
      <span className="event-date">{end && end !== start ? `${start} – ${end}` : start}</span>
      <span className="card-title">{e.title}</span>
      {e.location && <span className="muted small">{e.location}</span>}
      {e.summary && <span className="small">{e.summary}</span>}
      {e.signupUrl && (
        <a href={e.signupUrl} target="_blank" rel="noreferrer" className="btn btn-primary btn-small event-signup">{t.app.signup}</a>
      )}
    </div>
  )
}
